
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import BookingPropertiesPicker from "../components/BookingPropertiesPicker.vue";
import Booking from "../../../domain/booking/Booking";
import TimeService from "../../../services/TimeService";
import Room from "../../../domain/restaurant/Room";
import RemoteServices from "@/services/RemoteServices";
@Component({
  components: { BookingPropertiesPicker }
})
export default class CreateBookingFromWaitingList extends Vue {
  @Prop({ default: () => new Booking() })
  booking!: Booking;

  bookingCopy: Booking = Booking.copy(this.booking);

  isBookingPropertiesValid = true;

  currentDate: Date = new Date(this.booking.bookingDateTime);

  selectedTime = "";

  selectedRoom: Room | null = null;

  loading = false;

  @Prop({ default: () => {} })
  rooms!: { [key: number]: Room };

  mounted() {
    this.reset();
  }

  setSelectedRoom(newRoom: Room) {
    this.selectedRoom = newRoom;
  }

  getPreferredRoomFromBooking() {
    if (this.booking.preferredRoomId != null)
      this.selectedRoom = this.rooms[this.booking.preferredRoomId];
    else this.selectedRoom = null;
  }

  setBookingDate(newDate: any) {
    this.currentDate = newDate;
    this.setBookingTime("");
  }

  setBookingTime(newTime: string) {
    this.selectedTime = newTime;
    this.setBookingDateTime();
  }

  setBookingDateTime() {
    if (this.selectedTime !== "") {
      TimeService.setDateHours(this.currentDate, this.selectedTime);
      this.bookingCopy.bookingDateTime = TimeService.getISO8601DateTimeString(
        this.currentDate
      );
    } else this.bookingCopy.bookingDateTime = "";
  }

  resetCopy() {
    this.bookingCopy = Booking.copy(this.booking);
    this.currentDate = new Date(this.booking.bookingDateTime);
    this.selectedTime = TimeService.getTimeFromISOString(
      this.booking.bookingDateTime
    );
    // this.isRequestedTable = this.bookingCopy.isRequestedTable();
    this.getPreferredRoomFromBooking();
    // this.resetCurrentDate();
  }

  @Watch("booking")
  reset() {
    if (this.booking != null && !!this.booking.bookingDateTime) {
      this.resetCopy();
    }
  }

  async createBookingFromWaitingList() {
    this.loading = true;
    try {
      const updated = await RemoteServices.createBookingFromWaitingList(
        this.bookingCopy
      );
      await this.$store.dispatch(
        "success",
        this.$t("booking.waitingList.create.success")
      );
      this.$emit("update-booking", updated);
    } catch (error) {
      await this.$store.dispatch("error", error.message);
    }
    this.loading = false;
  }
}
